import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { TaketestComponent } from '../app/Test/app.taketest'
import {TakeTestModule} from '../app/Test/app.taketest.module';
import { SurveyFormComponent } from '../app/SurveyForm/app.surveyform'
import {SurveyFormModule} from '../app/SurveyForm/app.surveydirective';
import { ExamPackageComponent } from '../app/exampackage/exampackage.component'
import { ExamPackageModule } from './exampackage/app.exampackagemodule';
import { ReviewComponent } from '../app/Review/app.review.component';
import { TestReviewModule } from '../app/Review/app.review.module';
import * as myGlobals from "../globals";
export const routes: Routes = [
    { path: myGlobals.appPath+'/PlayTest.aspx', component: TaketestComponent },
    { path:  myGlobals.appPath+'/Test/PlayTest.aspx', component: SurveyFormComponent },
    { path:  myGlobals.appPath+'/Test/ExamPackage.aspx', component: ExamPackageComponent },
    { path: myGlobals.appPath + '/TestReview.aspx', component: ReviewComponent },
    { path: myGlobals.appPath + '/TestTryout.aspx', component: TaketestComponent }
];
@NgModule({
    imports: [RouterModule.forRoot(routes), TakeTestModule, ExamPackageModule, SurveyFormModule, TestReviewModule],
    exports: [RouterModule]
})
export class AppRoutingModule { }

export const routedComponents = []; 



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/app.routes.ts